import ImpactClaimDocumentSelection from 'components/Desktop/ImpactClaims/ImpactClaimDocumentSelection';
import { SelectedImpactClaimBlock } from 'components/Mobile/ImpactClaims';
import { ImpactClaimLocation, SlideHeader } from 'components/Shared';
import { ImpactClaimCategoryColored } from 'components/Shared/ImpactClaims';
import { StackedArea, useStackableBreadcrumbs, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import { impactCategoryConfig } from 'constants/impactCategoryConfig';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breadcrumbUtils } from 'utils';
import { ProductJourneyPages } from '../pages';
import DocumentSlide from './DocumentSlide';
import { getPrimaryImage } from 'utils/supplyChain';
const ColoredBackground = styled.div `
  position: relative;

  // Fills the background with the desired color.
  // The z-index:-1 makes sure that all elements are above the background.
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    left: 0px;
    right: 0px;
    top: -20px;
    bottom: 0;
    background: ${({ color }) => color};
  }
`;
const Container = styled.div `
  height: 100%;
`;
const DetailsContainer = styled.div `
  padding: 0 32px 0 32px;
  overflow: auto;
  height: ${({ mobile }) => (mobile ? 'unset' : 'calc(100% - 200px)')};
`;
const ImpactClaimTitleContainer = styled.div `
  margin: -16px 0 16px 0;
  padding-bottom: 4px;
`;
const DetailedImpactClaimSlide = ({ mobile, impactClaim, activity, isIntegration, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const { activateStackedContent, deactivateActiveContent } = useStackableContent();
    const breadcrumbs = useStackableBreadcrumbs();
    const categoryName = impactClaim === null || impactClaim === void 0 ? void 0 : impactClaim.impactCatalogItem.category.type;
    const categoryColor = (_a = impactCategoryConfig[categoryName]) === null || _a === void 0 ? void 0 : _a.color;
    const handleOpenDocumentSlide = () => {
        if (mobile) {
            activateStackedContent({
                id: ProductJourneyPages.DOCUMENTS,
                area: StackedArea.PAGE,
                breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.DOCUMENTS, t),
                renderComponent: () => (React.createElement(DocumentSlide, { key: ProductJourneyPages.DOCUMENTS, mobile: mobile, documents: impactClaim.attachments, detailNode: activity })),
                isActive: true,
                layout: {
                    hasBackButton: true,
                    hasHeader: true,
                    hasHeaderScrollEffect: false,
                    hasFooter: true,
                },
            });
        }
        else {
            activateStackedContent({
                id: ProductJourneyPages.DOCUMENTS,
                area: isIntegration ? StackedArea.SIDEBAR : StackedArea.CONTENT,
                breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.DOCUMENTS, t),
                isActive: true,
                layout: null,
                renderComponent: () => {
                    if (isIntegration) {
                        return (React.createElement(DocumentSlide, { key: ProductJourneyPages.DOCUMENTS, mobile: mobile, documents: impactClaim.attachments, detailNode: activity }));
                    }
                    return (React.createElement(ImpactClaimDocumentSelection, { goBack: deactivateActiveContent, renderOnProductJourney: true, impactClaim: impactClaim }));
                },
            });
        }
    };
    return (React.createElement(Container, null,
        React.createElement(ColoredBackground, { color: categoryColor },
            React.createElement(SlideHeader, { mobile: mobile, onPrev: deactivateActiveContent, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-impact-claims'), renderOnImpactClaims: true, backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
            React.createElement(ImpactClaimTitleContainer, null,
                React.createElement(ImpactClaimCategoryColored, { impactClaim: impactClaim }))),
        React.createElement(DetailsContainer, { mobile: mobile },
            React.createElement(ImpactClaimLocation, { title: activity === null || activity === void 0 ? void 0 : activity.title, componentTitle: (_b = impactClaim === null || impactClaim === void 0 ? void 0 : impactClaim.component) === null || _b === void 0 ? void 0 : _b.title, location: activity === null || activity === void 0 ? void 0 : activity.site.locationName, locationImage: getPrimaryImage(activity === null || activity === void 0 ? void 0 : activity.mediaList) }),
            React.createElement(SelectedImpactClaimBlock, { definitionTitle: impactClaim.impactCatalogItem.title, impactClaim: impactClaim, goToDocuments: handleOpenDocumentSlide }))));
};
export default DetailedImpactClaimSlide;
